import script from "./PublicLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicLayout.vue?vue&type=script&setup=true&lang=js"

import "./PublicLayout.vue?vue&type=style&index=0&id=aa9ed97c&lang=scss"

const __exports__ = script;

export default __exports__